// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"fefb6c6a","977":"2f9834e6"}[chunkId] + ".chunk.js";
};